// extracted by mini-css-extract-plugin
module.exports = {"routeView":"RouteCard_routeView__3N6zO"};